import Http from "@/api/http";

export default {
  /* 学生管理 */
  /* 学生 列表 */
  studentBasicPage: params => {
    return Http.POST("/studentBasic/findByPage", params);
  },
  /* 学生 新增/修改 */
  studentBasicSave: params => {
    return Http.POST("/studentBasic/save", params);
  },
  /* 学生 导入上传 */
  studentBasicImportFile: params => {
    return Http.POST("/studentBasic/importFile", params);
  },
  // 删除
  studentBasicDelete: params => {
    return Http.GET("/studentBasic/delete", params);
  },
};
